import React from 'react'
import styles from './CtaIntroduce.module.css'
import { CtaIntroduceProps, ImageItems } from './types'

const IMAGES: ImageItems = {
    messageIcon: {src: '/pages/google/CtaIntroduce/message_free.png', alt: '完全無料で'},
    nextIcon: {src: '/pages/google/CtaIntroduce/next.png', alt: '次へ進むアイコン'},
}

const CtaIntroduce: React.FC<CtaIntroduceProps> = ({
                                                       onCtaClick,
                                                       dataClickLabel
                                                   }) => {
    const fixedHref = '/signup?channel=googleadwords&p=3&ctaId=1'

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()

        if (onCtaClick) {
            onCtaClick({})
        } else {
            window.location.href = fixedHref
        }
    }
    return (
        <section className={styles.cta}>
            <div className={styles.ctaButton}>
                <a
                    href={fixedHref}
                    className={styles.ctaLink}
                    onClick={handleClick}
                    data-click-label={dataClickLabel}
                >
                    <img
                        src={IMAGES.messageIcon.src}
                        alt={IMAGES.messageIcon.alt}
                        className={styles.messageIcon}
                    />
                    <span className={styles.ctaText}>希望の求人を紹介してもらう</span>
                    <img
                        src={IMAGES.nextIcon.src}
                        alt={IMAGES.nextIcon.alt}
                        className={styles.nextIcon}
                    />
                </a>
            </div>
        </section>
    )
}

export default CtaIntroduce
